import { Page } from '@/core/architecture'

import { ConsoleRevenueTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleRevenue Page
 * Implemented as a practical sample.
 */
export const ConsoleRevenue: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleRevenueTemplate state={state} {...actions} />
}
